import React from 'react';
import PropTypes from 'prop-types';
import './StackedItemsDragPreview.scss';
import {FmlxIcon} from 'fmlx-common-ui';

const itemWidth = 76;
const itemHeight = 78;
const space = 4;

function getStackContainerStyle(count) {
  const containerWidth = itemWidth + space * (count - 1);
  const containerHeight = itemHeight + space * (count - 1);

  return {
    position: 'relative',
    width: containerWidth,
    height: containerHeight,
  };
}

function getPositionStyle(idx) {
  return {
    position: 'absolute',
    width: itemWidth,
    height: itemHeight,
    top: idx * space,
    left: idx * space,
  };
}

function StackedItemsDragPreview(props) {
  const {iconName, itemCount = 0, maxStack = 5} = props;

  const stackCount = Math.min(itemCount, maxStack);

  return (
    <div className="stacked-items-drag-preview">
      <div className="stack-container" style={getStackContainerStyle(stackCount)}>
        {/* eslint-disable-next-line prefer-spread */}
        {Array.apply(null, Array(stackCount || 1)).map((_, idx, arr) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            className="item-preview"
            style={getPositionStyle(idx)}
          >
            {idx === stackCount - 1 ? <FmlxIcon name={iconName} size="lg" customColor="#FFFFFF" /> : null}

            {itemCount > 1 && idx === arr.length - 1 ? (
              <div className="badge-overlay-container">
                <span className="drag-preview-badge">
                  <span className="count-text">{itemCount}</span>
                </span>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}

StackedItemsDragPreview.propTypes = {
  iconName: PropTypes.string.isRequired,
  itemCount: PropTypes.number,
  maxStack: PropTypes.number,
};

StackedItemsDragPreview.defaultProps = {
  itemCount: 0,
  maxStack: 5,
};

export default React.memo(StackedItemsDragPreview);
